import { BenefitStatus } from '@zorro/clients';
import { parseDateUnknown } from '@zorro/shared/formatters';
import { DeepReadonly } from '@zorro/types';

const cobraEligibleBenefitStatuses: DeepReadonly<{
  [benefitStatus in BenefitStatus]: boolean;
}> = {
  [BenefitStatus.IN_CART]: false,
  [BenefitStatus.AWAITING_MEDICAL]: false,
  [BenefitStatus.READY_TO_APPLY]: false,
  [BenefitStatus.AWAITING_EMPLOYEE]: false,
  [BenefitStatus.CARRIER_APPLICATION_SENT]: false,
  [BenefitStatus.AWAITING_PAYMENT]: true,
  [BenefitStatus.ENROLLMENT_CONFIRMED]: true,
  [BenefitStatus.ACTIVE]: true,
  [BenefitStatus.ENDED]: true,
};

/**
 * Check if employee is eligible for COBRA termination email
 * Requirements:
 * 1. Has terminationDate & eligibleUntil
 * 2. The period is not waived and its medical plan is confirmed in the
 *    carrier's book: AWAITING_PAYMENT, ENROLLMENT_CONFIRMED, ACTIVE or ENDED
 * 3. terminationDate within coverage period (effectiveFrom to effectiveUntil)
 * 4. eligibleUntil within coverage period
 */
export function checkCobraEligibility(
  effectiveFrom: string,
  effectiveUntil: string,
  benefitStatus: BenefitStatus | null,
  isWaived: boolean,
  terminationDateString: string | null,
  eligibleUntilString: string | null
): boolean {
  if (!terminationDateString || !eligibleUntilString || isWaived) {
    return false;
  }

  if (!benefitStatus || !cobraEligibleBenefitStatuses[benefitStatus]) {
    return false;
  }

  const terminationDate = parseDateUnknown(terminationDateString);
  const eligibleUntil = parseDateUnknown(eligibleUntilString);

  return (
    terminationDate.isBetween(effectiveFrom, effectiveUntil, 'day', '[]') &&
    eligibleUntil.isBetween(effectiveFrom, effectiveUntil, 'day', '[]')
  );
}
